<template>
  <div class="AddEnterpriseSeries">
    <AppHeader v-if="isAdd" :content="isAddContent"></AppHeader>
    <AppHeader v-else :content="isEditContent"></AppHeader>
    <AppBox class="appBox">
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <el-form-item label="系列名称" prop="name">
          <el-input
              style="width: 30%"
              placeholder="不得超过8个文字"
              v-model="formData.name"
          ></el-input>
        </el-form-item>
        <!--        <el-form-item label="系列标签">-->
        <!--          <el-input-->
        <!--              style="width: 14.5%"-->
        <!--              v-model="formData.tags[0]"-->
        <!--              placeholder="不得超过5个文字"-->
        <!--          ></el-input>-->
        <!--          <el-input-->
        <!--              style="margin-left: 1%; width: 14.5%"-->
        <!--              v-model="formData.tags[1]"-->
        <!--              placeholder="不得超过5个文字"-->
        <!--          ></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="上级分类" prop="classTreeId">
          <el-cascader
              v-model="formData.classTreeId"
              style="width: 30%"
              :options="options"
              :show-all-levels="false"
              filterable
              clearable
              :props="{
              emitPath: false,
            }"
          >
          </el-cascader>
        </el-form-item>
        <!--        <el-form-item label="上传封面">-->
        <!--          <el-upload-->
        <!--              action="#"-->
        <!--              :show-file-list="false"-->
        <!--              :auto-upload="false"-->
        <!--              :on-success="handleAvatarSuccess"-->
        <!--              :on-change="handleImgChange"-->
        <!--              :before-upload="beforeAvatarUpload"-->
        <!--          >-->
        <!--            <img v-if="imageUrl" :src="imageUrl" class="avatar" alt=""/>-->
        <!--            <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
        <!--            <div>-->
        <!--              <el-button-->
        <!--                  class="btn"-->
        <!--                  v-if="imageUrl"-->
        <!--                  size="mini"-->
        <!--                  plain-->
        <!--                  type="primary"-->
        <!--              >重新上传-->
        <!--              </el-button>-->
        <!--              <MaterialPicker-->
        <!--                  materialType="image"-->
        <!--                  @onConfirmPickMaterial="onConfirmPickMaterial"-->
        <!--              ></MaterialPicker>-->
        <!--            </div>-->
        <!--          </el-upload>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="添加老师" prop="userId">-->
        <!--          <el-select-->
        <!--              style="width: 30%"-->
        <!--              v-model="formData.userId"-->
        <!--              placeholder="请选择"-->
        <!--          >-->
        <!--            <el-option-->
        <!--                v-for="item in tenantDepartmentUserList.data"-->
        <!--                :key="item.userId"-->
        <!--                :label="item.nickname"-->
        <!--                :value="item.userId"-->
        <!--            >-->
        <!--            </el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
      </el-form>
      <div class="footer">
        <el-button style="margin-right: 200px;width: 150px" type="primary" @click="handleConfirm"
        >保存
        </el-button>
        <el-button v-if="isAdd" style="width: 150px" type="primary" @click="handleConfirmAndContinue"
        >继续新增
        </el-button>
      </div>
    </AppBox>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import {enterpriseSeries} from "@/pages/SeriesManagement/enterpriseSeries";
import {mapActions, mapState} from "vuex";
import MaterialPickModal from "@/pages/MaterialCenter/components/MaterialPickModal.vue";
import MaterialPicker from "@/pages/MaterialCenter/components/MaterialPicker.vue";

export default {
  name: "AddEnterpriseSeries",
  components: {MaterialPicker, MaterialPickModal, AppBox, AppHeader},
  mixins: [enterpriseSeries],
  data() {
    return {
      isAdd: true,
      isAddContent: "系列管理 | 新增系列",
      isEditContent: "系列管理 | 编辑系列",
      options: [],
    };
  },
  computed: {
    ...mapState("teachingCenter", ["classifyList"]),
    // ...mapState("administrativeCenter", ["tenantDepartmentUserList"]),
  },
  async mounted() {
    //调用分类列表，显示分类下拉option
    await this.getClassTree({
      parentId: null,
    });
    this.options = this.formatData(this.classifyList.data);
    // 新增系列
    if (this.$route.params.type === "add") {
      this.clearForm();
      if (Number(this.$route.params.id) !== 0) {
        // 从目录点进来新增
        this.formData.classTreeId = Number(this.$route.params.id);
      } else {
        //默认分类为第一个
        this.formData.classTreeId = this.classifyList.data[0].id;
      }
      this.isAdd = true;
    }
    // 编辑系列
    if (this.$route.params.type === "edit") {
      this.isAdd = false;
      const classSubjectDetail = JSON.parse(
          localStorage.getItem("classSubjectDetail")
      );
      Object.keys(this.formData).map((key) => {
        this.formData[key] = classSubjectDetail[key];
      });
      this.imageUrl = classSubjectDetail.materialUrl;
      if (!this.formData.tags) {
        this.formData.tags = [];
      }
    }
    //拉取老师人员列表
    // await this.getTenantDepartmentUser({
    //   roleName: "老师",
    //   page: null,
    //   size: null,
    // });
  },
  methods: {
    ...mapActions("teachingCenter", ["getClassTree"]),
    ...mapActions("administrativeCenter", ["getTenantDepartmentUser"]),
    onConfirmPickMaterial(item) {
      this.imageUrl = item.url;
      this.formData.materialId = item.id;
    },
    formatData(val) {
      let newVal = [];
      val.map((item, index) => {
        if (item.children) {
          newVal[index] = {
            value: item.id,
            label: item.name,
            children: this.formatData(item.children),
          };
        } else {
          newVal[index] = {
            value: item.id,
            label: item.name,
          };
        }
      });
      return newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
.AddEnterpriseSeries {
  .appBox {
    width: 100%;
    min-height: calc(100vh - 155px);

    ::v-deep .el-radio__inner {
      border: 1px solid #dcdfe6;
      border-radius: 100%;
      width: 180px !important;
      height: 14px;
      background-color: #ffffff;
      position: relative;
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
    }

    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 200px;
      height: 140px;
      line-height: 100px;
      text-align: center;
      border: 1px solid #dcdfe6;
    }

    .avatar {
      width: 200px;
      height: 140px;
      display: block;
    }

    .btn {
      text-align: right;
    }

    .footer {
      margin-top: 150px;
      text-align: center;
    }
  }
}
</style>
